import { render, staticRenderFns } from "./MemoDeals.vue?vue&type=template&id=0a1e2384&scoped=true&"
import script from "./MemoDeals.vue?vue&type=script&lang=js&"
export * from "./MemoDeals.vue?vue&type=script&lang=js&"
import style0 from "./MemoDeals.vue?vue&type=style&index=0&id=0a1e2384&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a1e2384",
  null
  
)

export default component.exports